<h1 mat-dialog-title>Set to DO NOT INVOICE</h1>
<div mat-dialog-content>
    <p>Are you sure you want to set the selected timesheet(s) to 'Do Not Invoice'?</p>
</div>
<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" mat-dialog-close>No</button>
    <button mat-flat-button color="primary" (click)="confirm()">Yes</button>
</mat-dialog-actions>
